import XAPPService from "app/Core/services/XAPPService";
import history from "history.js";
export const PAGAMENTO_WARNING = "[PAGAMENTO APP] PAGAMENTO WARNING";
export const PAGAMENTO_INFO = "[PAGAMENTO APP] PAGAMENTO INFO";
export const PAGAMENTO_ERROR = "[PAGAMENTO APP] PAGAMENTO ERROR";
export const PAGAMENTO_CLEAR = "[PAGAMENTO APP] PAGAMENTO CLEAR";
export const CHANGE_PRELOAD = "[PAGAMENTO APP] CHANGE PRELOAD";
export const PAGAMENTO_CONFIRMADO = "[PAGAMENTO APP] PAGAMENTO CONFIRMADO";
export const VERIFICANDO_PAGAMENTO = "[PAGAMENTO APP] VERIFICANDO PAGAMENTO";

export function save(_AValue, _AAction, _AParams) {
    return (dispatch, getState) => {
        if (!getState().Pagamento.preload) {
            dispatch({ type: CHANGE_PRELOAD });
        }

        let AActions = [];
        if (_.isUndefined(_AValue.sistema) || _.isNull(_AValue.sistema)) {
            _AValue.sistema = sessionStorage.getItem("sistema");
        }
        if (_.isUndefined(_AValue.sistema) || _.isNull(_AValue.sistema)) {
            _AValue.sistema = getState().auth.user.data.settings.tipo;
        }
        if (_.isUndefined(_AValue.plano) || _.isNull(_AValue.plano)) {
            _AValue.plano = sessionStorage.getItem("plano");
        }
        AActions = XAPPService.XappIntegracaoActionFactory(_AParams.empresa, AActions, "", _AAction, _AValue);

        XAPPService.XappIntegracaoAction(AActions, _AParams, "ASAAS")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: PAGAMENTO_WARNING,
                            payload: response.warning
                        })
                    ]);
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: PAGAMENTO_INFO,
                            payload: response.info,
                            data: response.data
                        })
                    ]);
                }
            }).catch(error => {
                return dispatch({
                    type: PAGAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function cancelarAssinatura(_AValue, _AParams, _ACallback = null) {
    return (dispatch) => {
        let AActions = [];
        AActions = XAPPService.XappIntegracaoActionFactory(_AParams.empresa, AActions, "", "CANCELAR-ASSINATURA", _AValue);

        XAPPService.XappIntegracaoAction(AActions, _AParams, "ASAAS")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: PAGAMENTO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: PAGAMENTO_INFO,
                            payload: response.info,
                            data: response.data
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
            }).catch(error => {
                return dispatch({
                    type: PAGAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: PAGAMENTO_CLEAR
    }
}

export function verificarPagamento(_AValue, _AParams) {
    return (dispatch) => {
        dispatch({ type: VERIFICANDO_PAGAMENTO, value: true });

        let AActions = [];
        AActions = XAPPService.XappIntegracaoActionFactory(_AParams.empresa, AActions, "", "VERIFICAR-PAGAMENTO", _AValue);

        XAPPService.XappIntegracaoAction(AActions, _AParams, "ASAAS")
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    let AData = JSON.parse(response.data)[0].data;
                    if (!_.isNull(AData) && AData.length > 0) {
                        Promise.all([
                            dispatch({ type: PAGAMENTO_CONFIRMADO }),
                        ]);
                        history.push("/home");
                    }
                    else {
                        dispatch({ type: VERIFICANDO_PAGAMENTO, value: false });
                    }
                }
            }).catch(error => {
                return dispatch({
                    type: PAGAMENTO_ERROR,
                    payload: error
                });
            });
    };
}